export default "__VITE_ASSET__d6882ce3__"